/* -----------------UI--------------- */
import { Dialog, IconButton, Portal } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import { ToastProvider } from "../Toast";

import { Platform, type StyleProp, type ViewStyle } from "react-native";

const isWeb = Platform.OS === "web";

type Props = {
	visible: boolean;
	handleClose?: () => void;
	children: React.ReactNode;
	maxWidth?: unknown;
	showCloseButton?: boolean;
	height?: `${number}%` | number;
	bottom?: number;
	minHeight?: number | `${number}%`;
	width?: number | `${number}%`;
	style?: StyleProp<ViewStyle>;
};
const DialogWrapper = ({
	visible,
	handleClose,
	children,
	bottom,
	height,
	minHeight,
	width = "80%",
	showCloseButton,
	style,
}: Props) => {
	const theme = useAppTheme();
	return (
		<Portal>
			<ToastProvider>
				<Dialog
					visible={visible}
					onDismiss={handleClose}
					style={{
						width,
						alignSelf: "center",
						bottom: bottom || 0,
						height,
						minHeight,
						overflow: "hidden",
						maxHeight: isWeb ? "90%" : undefined,
						...theme.componentOverrides.dialog,
						...style,
					}}
				>
					{children}
					{showCloseButton && (
						<Box position="absolute" top={12} right={12}>
							<IconButton icon="close" onPress={handleClose} />
						</Box>
					)}
				</Dialog>
			</ToastProvider>
		</Portal>
	);
};

export default DialogWrapper;
